<template>
  <div class="modal-body text-start">
    {{ content }}
  </div>
</template>

<script>
export default {
  name: "ModalContentComponent",
  props: {
    content: String,
  },
};
</script>

<style scoped></style>
